import { type ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { ForgePageLoader } from "@/components/ForgeLoader";
import { useResolveContextWithLoading } from "@/hooks/useCapability";
import { isPortalVisible } from "@/lib/capabilities/portal";

interface MemberCapabilityRouteProps {
  capability: string;
  children: ReactNode;
  redirectTo?: string;
}

/**
 * Member-portal route guard. Unlike {@link CapabilityRouteGate} (staff-oriented,
 * renders an upgrade card on tier-block), a member should never see a staff
 * upgrade prompt — for both tier-blocked and toggled-off capabilities we simply
 * redirect to the portal home. Placed INSIDE the existing member-auth boundary,
 * around the page element, so it never bypasses authentication.
 */
export function MemberCapabilityRoute({
  capability,
  children,
  redirectTo = "/member",
}: MemberCapabilityRouteProps) {
  const { ctx, isLoading } = useResolveContextWithLoading();

  if (isLoading) return <ForgePageLoader />;
  if (!isPortalVisible(capability, ctx)) return <Navigate to={redirectTo} replace />;
  return <>{children}</>;
}
